import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import JourneyStages from "@/components/JourneyStages";

export default function GrowthJourney() {
  return (
    <div>
      <section className="pt-16 md:pt-24 pb-16 md:pb-20 border-b border-[#27272a] relative overflow-hidden">
        <div className="absolute inset-0 radial-fade" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-3xl">
            <div className="eyebrow mb-6">
              <span className="gold-line" />
              Your Growth Journey
            </div>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]">
              A path that <br />
              <span className="text-[#C8A24B]">meets you where you are.</span>
            </h1>
            <p className="mt-8 text-lg text-[#a1a1aa] leading-relaxed max-w-2xl">
              No matter where you are right now, the next step should feel
              obvious. You do not need to know exactly what you need before you
              contact us. That is part of what we help figure out.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <JourneyStages />
        </div>
      </section>

      <section className="py-20 md:py-28 border-t border-[#27272a] bg-[#0d0d0d]">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <h2 className="font-heading text-3xl md:text-4xl text-white leading-tight">
            You do not need to know exactly what package you need yet.
          </h2>
          <p className="text-[#a1a1aa] mt-6 max-w-2xl mx-auto">
            That is part of what we help determine.
          </p>
          <Link to="/contact" className="btn-gold mt-10 inline-flex">
            Start with a growth assessment <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </div>
  );
}
